import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChooseServicePlanComponent } from './choose-service-plan/choose-service-plan.component';
import { ReviewVenueComponent } from './review-venue/review-venue.component';
import { VenueConfirmationComponent } from './venue-confirmation/venue-confirmation.component';
import { LoginComponent } from './login/login.component';
import { VenueTypeComponent } from './venue-type/venue-type.component';
import { CanDeactivateGuard } from './guards/can-deactivate.guard';
import { marketingEnabledGuard } from './guards/marketing-enabled.guard';
import { MainComponent } from './main/main.component';

const routes: Routes = [
  {
    path: 'marketing',
    canMatch: [marketingEnabledGuard],
    loadChildren: () => import('./marketing/marketing.module').then((m) => m.MarketingModule),
  },
  {
    // MainComponent is the venue-signup shell (header, stepper, step redirects);
    // it must not be instantiated for /marketing routes.
    path: '',
    component: MainComponent,
    children: [
      {
        path: '',
        component: LoginComponent,
        title: 'Account – BlazeBite Signup',
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'login',
        component: LoginComponent,
        title: 'Account – BlazeBite Signup',
        canDeactivate: [CanDeactivateGuard],
      },
      { path: 'venueType', component: VenueTypeComponent, title: 'Venue – BlazeBite Signup' },
      { path: 'choosePlan', component: ChooseServicePlanComponent, title: 'Plan – BlazeBite Signup' },
      { path: 'review', component: ReviewVenueComponent, title: 'Review – BlazeBite Signup' },
      { path: 'confirmation', component: VenueConfirmationComponent, title: 'Confirmation – BlazeBite Signup' },
    ],
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
